import { render, staticRenderFns } from "./RemoveStaffPopup.vue?vue&type=template&id=470de143&scoped=true&"
import script from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveStaffPopup.vue?vue&type=style&index=0&id=470de143&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470de143",
  null
  
)

export default component.exports